var {debounce} = require('@exadel/esl/modules/esl-utils/async/debounce');
var {ESLMediaQuery} = require('@exadel/esl/modules/esl-media-query/core');

var {AmpersandView} = require('catalog/libs');

var HPEServices = require('../../base/hpe.services');
var HPEConstants = require('../../base/hpe.constants');

var CatalogCompareTrayItemView = require('./item/hpe.catalog.comparetray.item.view');

/**
 * Product Catalog Compare Tray View
 */
module.exports = AmpersandView.extend({

    autoRender: true,

    /**
     * initialization
     */
    initialize: function() {
    },

    /**
     * bindings
     */
    bindings: {
        'model.isInited': {
            type: 'booleanClass',
            hook: 'catalog-compare-tray',
            name: 'initialized'
        },
        'model.isFixed': {
            type: 'booleanClass',
            hook: 'catalog-compare-tray',
            name: 'fixed'
        },
        'model.isOpen': [
            {
                type: 'booleanClass',
                hook: 'catalog-compare-tray',
                name: 'open'
            },
            {
                //do not allow any specified CTA inside tray to receive keyboard focus unless tray open
                type: function(el, value) {
                    var i;
                    var tabIndex = (value) ? 0 : -1;
                    var childCTAList = document.querySelectorAll('.catalog-compare-cta');
                    el.setAttribute('aria-hidden', !value);
                    for (i = 0; i < childCTAList.length; i++) {
                        childCTAList[i].setAttribute('tabIndex', tabIndex);
                    }
                },
                hook: 'catalog-compare-tray'
            },
            {
                //add conditional class to body (outside component) in mobile breakpoint if tray open
                type: function(el, value) {
                    if (this.model.isMobile) {
                        if (value) {
                            document.body.classList.add('compare-tray');
                        } else {
                            document.body.classList.remove('compare-tray');
                        }
                    }
                },
                hook: 'catalog-compare-tray'
            }
        ],
        'model.isOpening': {
            type: 'booleanClass',
            hook: 'catalog-compare-tray',
            name: 'opening'
        },
        'model.isClosing': {
            type: 'booleanClass',
            hook: 'catalog-compare-tray',
            name: 'closing'
        },
        'model.itemCount': {
            type: 'text',
            hook: 'summary-count'
        },
        'model.summaryDescriptor': {
            type: 'text',
            hook: 'summary-descriptor'
        },
        'model.i18n.compare': {
            type: 'text',
            selector: '.catalog-compare-tray-compare'
        },
        'model.i18n.clear': {
            type: 'text',
            selector: '.catalog-compare-tray-clear'
        }
    },

    /**
     * events
     */
    events: {
        'click .catalog-compare-tray-clear': 'onClearClick',
        'click .catalog-compare-tray-compare': 'onCompareClick'
    },

    /**
     * template
     */
    template: function() {
        return require('./hpe.catalog.comparetray.template.tpl');
    },

    /**
     * subview definitions
     */
    subviews: {
        items: {
            hook: 'catalog-compare-tray-list',
            waitFor: 'model.items',
            prepareView: function(el) {
                return new CatalogCompareTrayItemView({
                    el: el,
                    collection: this.model.items
                });
            }
        }
    },

    /**
     * initialize scrolling behavior and events to handle position and animation for tray
     */
    initializeScrollingBehavior: function () {
        //initial measurement of cached values
        this.isMobile = ESLMediaQuery.for('@xs').matches;
        this.updateFixedPosition();

        //store event bindings
        this.onScroll = this.onScrollEvent.bind(this);
        this.onResize = debounce(this.update, 300, this);

        //scrolling related event listeners
        window.addEventListener('scroll', this.onScroll);
        window.addEventListener('resize', this.onResize);

        this.model.isInited = true;
    },

    /**
     * make a throttled requestanimationframe call to method that determins UI DOM position
     */
    requestScrollTick: function () {
        if (!this.model.isScrollTick) {
            window.requestAnimationFrame(this.updateFixedPosition);
        }
        this.model.isScrollTick = true;
    },

    update: function () {
      this.isMobile = ESLMediaQuery.for('@xs').matches;
      this.requestScrollTick();
    },

    /**
     * determine if the list UI should be fixed to bottom of screen
     */
    updateFixedPosition: function() {
        //do not calculate fixed position in views where tray is present but calculation is not needed
        if (!this.model.isPDPInstance || (this.model.isPDPInstance && !this.model.isMobile)) {
            const top = this.el.getBoundingClientRect().y;
            const height = parseFloat(window.getComputedStyle(this.el).height);
            const bound = window.innerHeight - height;

            //should the tray be fixed position to screen bottom
            this.model.isFixed = (top > bound);
        }

        //tray is always fixed on mobile PDP
        if (this.model.isEntitled && this.model.isPDPInstance && this.model.isMobile) {
            this.model.isFixed = true;
        }

        //reset requestAnimationFrame scroll throttle
        this.model.isScrollTick = false;
    },

    /**
     * handle click to compare CTA
     */
    onCompareClick: function(e) {
        e.preventDefault();
        HPEServices.publish(HPEConstants.catalog.COMPARE_PAGE_NAVIGATE);
    },

    /**
     * handle click to clear CTA
     */
    onClearClick: function() {
        this.model.removeAll();
    },

    /**
     * handle browser scroll event
     */
    onScrollEvent: function() {
        //make request for requestanimationframe fixed/scrolling UI update
        this.requestScrollTick();
    }
});
